<template>
<div class="goods">
    <van-nav-bar title="投票选举" left-text="返回" left-arrow @click-left="onClickLeft">
        <div slot="right" style="color:#1989fa;" @click="voteCand" >成为候选人</div>
        <!-- <div slot="right" @click="showPopup">
            <van-icon name="wap-nav" />
            导航
        </div> -->
    </van-nav-bar>
    <!-- <van-popup v-model="show" position="right" :style="{ height: '100%',width:'70%'}" closeable close-icon-position="top-left"> 
        <div class="means">
            <template>
                <img src="../assets/images/user/default_tx.png" class="portrait" />
            </template>
            <div class="means_name">
                <p>您好，欢迎登录！</p>
                <p>{{userInfo.name || '--'}}</p>
                <span>会员类型：{{getMemberType(userInfo.memberType) || '网员'}}</span>
            </div>
        </div>  
        <van-cell-group>
            <van-cell title="首页" is-link to="" />
            <van-cell title="会员中心" is-link to="MemberCenter" />
            <van-cell title="会议中心" is-link to="MeetingCenter" />
            <van-cell title="通知公告" is-link to="noticeList" />
            <van-cell title="问题反馈" is-link to="feedback" />
        </van-cell-group>
        <van-button type="info" block plain hairline @click="logout">退出</van-button>
    </van-popup> -->
</div>
</template>

<script type="text/javascript">
import {logout} from "@/api/dictionary";
import { NavBar,Button,Icon,Popup, Cell,CellGroup,Dialog,} from 'vant';
import {getSessionStore} from "@/utils/sessionStorage.js"
import {mapGetters, mapState} from "vuex";
export default {
  data() {
    return {
        title:"投票选举",
        show:false,
        value:'',
    };
  },
  components: {
    [NavBar.name]:NavBar,
    [Button.name]:Button,
    [Icon.name]:Icon,
    [Popup.name]:Popup,
    [CellGroup.name]:CellGroup,
    [Cell.name]:Cell,
    [Dialog.name]:Dialog,

  },
    computed:{
        ...mapState(["userInfo"]),
        ...mapGetters([ "getMemberType"]),
    },
  methods: {
    showPopup(){
         this.show = true;
    },
    logout() {
        Dialog.confirm({
            title: '标题',
            message: '您确认要退出？'
        }).then(() => {
            let token = getSessionStore("access_token");
            logout({"access_token":token}).then(res => {
                if(res.success){
                    this.$router.push({ name: "login" });
                }
            });
        })
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  voteCand(){
      this.$router.push({ name: "candidateList" }); 
  }
  },
  mounted() {
    
  }
};
</script>

<style lang="less" scoped>
.van-nav-bar{border-bottom:none; height: 55px; line-height: 55px; position: fixed; top:0; width:100%;}
/deep/.van-nav-bar .van-icon::before{ display: block; margin-top: -4px; color:#333;}
.means{ margin-top: 20%; padding: 0 3%; font-size:16px; text-align: center; line-height: 30px; margin-bottom: 40px;}
.means img{ width: 30%; display: block; margin: 0 auto; margin-bottom: 20px;}
/deep/.van-popup .van-cell-group{ margin-top: 20px; padding:0 10px;}
/deep/.van-popup .van-cell{ padding:15px 20px;}
/deep/.van-button--block{ width:80%; margin: 0 auto; margin-top: 30px;}
/deep/.van-popup--bottom{ padding-bottom: 15px;}
/deep/.van-hairline--top-bottom{ border-width:inherit; border-bottom: inherit;}
.van-nav-bar__title{ line-height: 60px;}
.van-nav-bar__title,.van-nav-bar__text{ color:#000 !important;}
</style>